import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { GtmService } from '@services/gtm/gtm.service';
import { DsButtonV2Component, DsCardComponent, DsInlineAlertComponent, DsRadioComponent, DsRadioGroupComponent } from '@customdesignsystem';
import { GenericErrorOps } from '@shared/components/design-system/generic-error/interfaces/generic-error-ops.interface';
import { DsGenericErrorComponent } from '@shared/components/design-system/generic-error/generic-error.component';
import { MESSAGE } from '@constants/tramite-pension-invalidez';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pi-pregunta-paso-0',
  standalone: true,
  imports: [CommonModule, DsCardComponent, DsButtonV2Component, DsRadioComponent, DsRadioGroupComponent, DsInlineAlertComponent, DsGenericErrorComponent],
  templateUrl: './pi-pregunta-paso-0.component.html',
  styleUrls: ['./pi-pregunta-paso-0.component.scss'],
})
export class PiPreguntaPaso0Component {
  accidenteLaboral: string | null = null;
  empleadoPublico: string | null = null;
  errorOps: GenericErrorOps | null = null;
  @Output() continuarPaso0 = new EventEmitter<void>();

  constructor(private readonly router: Router, private readonly gtmService: GtmService) {
    this.gtmService.handleStepTransition({
      paso_numero: 'pre_0',
      paso_nombre: 'antes_de_iniciar_solicitud',
      event_name: 'tramite_invalidez'
    });

    this.gtmService.trackGenericEvent('view', 'Vista de página', 'Vista de página', '-', this.router.url);
  }

  get continuarDeshabilitado(): boolean {
    return this.accidenteLaboral === null || this.empleadoPublico === null;
  }

  onAccidenteChange(value: any): void {
    console.log('Accidente laboral changed to:', value);
    if (value === 'si') {
      this.gtmService.trackGenericEvent('click', 'radio_accidente_enfermedad_laboral', 'Sí', 'radio_button', '', 'tu_invalidez_accidente_enfermedad_laboral');
    }
    else if (value === 'no') {
      this.gtmService.trackGenericEvent('click', 'radio_accidente_enfermedad_laboral', 'No', 'radio_button', '', 'tu_invalidez_accidente_enfermedad_laboral');
    }
    this.accidenteLaboral = value;
  }

  onEmpleadoPublicoChange(value: any): void {
    console.log('Empleado público changed to:', value);

    if (value === 'si') {
      this.gtmService.trackGenericEvent('click', 'radio_empleado_publico', 'Sí', 'radio_button', '', 'eres_empleado_publico');
    }
    else if (value === 'no') {
      this.gtmService.trackGenericEvent('click', 'radio_empleado_publico', 'No', 'radio_button', '', 'eres_empleado_publico');
    }
    this.empleadoPublico = value;
  }

  continuar(): void {
    this.gtmService.trackClick('boton_continuar', 'Continuar', 'boton_principal', this.router.url);
    if (this.accidenteLaboral === 'si') {
      this.gtmService.trackGenericEvent('view', 'mensaje_fin_tramite_ley_16744', 'el trámite finaliza aquí...', 'mensaje_informativo', this.router.url);
      this.errorOps = MESSAGE.MENSAJE_REALIZAR_SOLICITUD_MUTUALIDAD;
    }
    else if (this.accidenteLaboral === 'no') {
      this.continuarPaso0.emit();
    }
  }
}
